import React from 'react'
import { Selectbox } from 'view/components/options'
import { DurationInput, Field } from 'view/components/inputs'
import { ValidationIssue } from 'api'
import { padNumberStart } from 'utils'

interface RFQSelectboxProps {
  value: number
  className?: string
  readOnly?: boolean
  disabled?: boolean
  onUpdate: (value: number) => void
  validationIssues?: ValidationIssue[]
  dataTestId?: string
}

export const RFQSelectbox = React.forwardRef((props: RFQSelectboxProps, ref: React.Ref<Selectbox>) => {
  const { value, className, readOnly, disabled, validationIssues, onUpdate, dataTestId } = props

  const getDurationText = (duration: number) => {
    const hours = padNumberStart(Math.floor(duration / 60), 2)
    const minutes = padNumberStart(duration % 60, 2)

    return `${hours} : ${minutes}`
  }

  return (
    <Selectbox
      ref={ref}
      className={className}
      optionKeys={[5, 10, 15, 30, 60, 120, 180, 240]}
      getOptionText={getDurationText}
      value={value}
      readOnly={readOnly}
      disabled={disabled}
      onUpdate={onUpdate as any}
      validationIssues={validationIssues ?? []}>
      <DurationInput dataTestId={dataTestId} value={value} onUpdate={onUpdate} />
    </Selectbox>
  )
})

export const RFQSelectboxField = Field(RFQSelectbox)
